import React from 'react';
import PropTypes from 'prop-types';
import onServiceClick from '../share-buttons/onServiceClick';

/**
 * Individual Share Button
 */
const ShareButton = (props) => {
  const { serviceName, className, href } = props;

  return (
    <a
      aria-label="Share Button"
      href={href}
      onClick={(e) => onServiceClick(e, serviceName, href)}
    >
      <span className={className} />
    </a>
  );
};

ShareButton.propTypes = {
  serviceName: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired,
};

export default ShareButton;
